import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function PlanExamplesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={pricingData.planExamples.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.planExamples.title}
          </h2>
        </div>

        <div className="reveal grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8">
          {pricingData.planExamples.examples.map((example) => (
            <div
              key={example.id}
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-7 flex flex-col"
            >
              <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${example.icon} text-primary-600 text-lg`} />
              </div>

              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3">
                {example.title}
              </h3>

              <ul className="space-y-2 mb-5 flex-1">
                {example.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0 text-sm" />
                    <span className="text-sm text-foreground-700">{item}</span>
                  </li>
                ))}
              </ul>

              <div className="pt-4 border-t border-background-200/70 space-y-3">
                <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-bold border border-accent-200/60">
                  {example.priceLabel}
                </span>
                {example.priceValue && (
                  <p className="text-sm font-bold text-primary-700 font-heading">
                    {example.priceValue}
                  </p>
                )}
                {example.note && (
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {example.note}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="reveal text-center">
          <p className="text-sm text-foreground-500">
            {pricingData.planExamples.note}
          </p>
        </div>
      </div>
    </section>
  );
}